import React, {MouseEvent} from "react";
import copy from 'copy-to-clipboard';

import {useLayerPopupContext} from "../../contexts";

const BroadCastShare = () => {
  const {
    share: { title, url },
    close
  } = useLayerPopupContext()

  return (
    <article
      className="popup"
      style={{width: "auto", margin: "-130px 0 0 -215px"}}
    >
      <div className="titB">
        <h1>{title}</h1>
        <a
          href="#!"
          title="닫기"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            close()
          }}
        >
          닫기
        </a>
      </div>
      <div className="txtB shareB">
        <input
          type={"text"}
          value={url}
        >
        </input>
        <button
          type={"button"}
          onClick={() => {
            copy(url)
          }}>
          복사
        </button>

      </div>
    </article>
  )
}

export default BroadCastShare